import React, { FC, useEffect, useRef, useState } from 'react';
import { checkMousePosition } from '../../helpers/stylesEffects';
import { getTotalBackgroundLogos } from '../../helpers/getTotalBackgroundLogos';

import './BGHoverComponent.scss';
import { MenuItems } from '../../types/MenuItems';

type Props = {
  conteinerWidth?: number;
  customLogoClassName?: string;
};

export const BGHoverComponent: FC<Props> = ({
  conteinerWidth,
  customLogoClassName = '',
}) => {
  const bgHoverContainer = useRef<HTMLDivElement>(null);
  const [imagesList, setImagesList] = useState<number[]>([]);
  const { hash } = window.location;

  useEffect(() => {
    if (window.screen.width >= 990) {
      document.addEventListener('mousemove', checkMousePosition);
    }

    if (bgHoverContainer.current) {
      const images = getTotalBackgroundLogos(
        bgHoverContainer.current,
        conteinerWidth,
      );

      setImagesList(images);
    }
  }, [bgHoverContainer.current?.offsetHeight, window.location.hash]);

  return (
    <div ref={bgHoverContainer} className="bg-hover-container">
      {imagesList.map((i) => (
        <img
          src="images/hover_logo_light.svg"
          className={`bg-logo ${customLogoClassName}`}
          loading="lazy"
          alt=""
          key={i}
        />
      ))}
    </div>
  );
};
